/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-var-requires */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
const parse = require('json-parse-safe');

import { Subject } from 'rxjs';
import VueMask from 'v-mask';

export const eventHub = new Vue();

import './plugins/axios';
import './plugins/vuetify-dialog';
import './plugins/codes';
import './plugins/moment';
import './plugins/validation';
import './plugins/currency';
import './plugins/currency-field';
import './common/filters/defaultDate.filter';
import './styles/main.scss';
import InternalPageHeader from '@/components/InternalPageHeader.vue';
import PageState from '@/components/PageState.vue';
import CreditorAccessNotice from '@/components/CreditorAccessNotice.vue';
import './styles/internal-pages.scss';

Vue.component('InternalPageHeader', InternalPageHeader);
Vue.component('PageState', PageState);
Vue.component('CreditorAccessNotice', CreditorAccessNotice);

Vue.config.productionTip = false;

Vue.filter('enum', (value: any, data: any[], valueProperty: any, textProperty: any) => {
    if (!valueProperty) {
        valueProperty = 'id';
    }
    if (!textProperty) {
        textProperty = 'name';
    }

    const item = data.find((item: { [x: string]: any }) => item[valueProperty] === value);

    if (item) {
        return item[textProperty];
    }

    return value;
});

Vue.use(VueMask);

new Vue({
    router,
    vuetify,
    render: (h) => h(App),
    data: {
        title: '-',
        user: {},
        actions: {
            suggest: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            },
            download: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            },
            publish: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            },
            history: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            },
            import: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            },
            upload: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            },
            address: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            },
            sync: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            },
            productivity: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            },
            create: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            },
            remove: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            },
            edit: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            },
            editnew: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            },
            save: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            },
            group: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            },
            add: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            },
            filter: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            },
            store: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            },
            file: {
                visible: false,
                disable: false,
                loading: false,
                event: new Subject()
            }
        }
    },
    methods: {
        show: function (action: any) {
            this.actions.suggest.visible = !!action.suggest;
            this.actions.download.visible = !!action.download;
            this.actions.publish.visible = !!action.publish;
            this.actions.history.visible = !!action.history;
            this.actions.import.visible = !!action.import;
            this.actions.upload.visible = !!action.upload;
            this.actions.address.visible = !!action.address;
            this.actions.sync.visible = !!action.sync;
            this.actions.productivity.visible = !!action.productivity;
            this.actions.create.visible = !!action.create;
            this.actions.remove.visible = !!action.remove;
            this.actions.editnew.visible = !!action.editnew;
            this.actions.edit.visible = !!action.edit;
            this.actions.save.visible = !!action.save;
            this.actions.group.visible = !!action.group;
            this.actions.add.visible = !!action.add;
            this.actions.filter.visible = !!action.filter;
            this.actions.store.visible = !!action.store;
            this.actions.file.visible = !!action.file;
        }
    },
    created: function () {
        this.user = parse(localStorage.getItem('user')).value;
    }
}).$mount('#app');
